import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","justify-content":"center","align-items":"center","height":"60vh","flex-direction":"column"} }

import { onMounted,reactive } from "vue";
import axiosInstance from "@/utils/axiosInstance";
import { useRouter } from "vue-router";
import { useOAuthStore } from "@/stores/oauth";
import { useUserInfoStore } from "@/stores/userInfo";
import { ElMessage } from "element-plus";


export default /*@__PURE__*/_defineComponent({
  __name: 'OAuthGithub',
  setup(__props) {

const router = useRouter();
const authStore = useOAuthStore();
const userInfoStore = useUserInfoStore();

const pagestate = reactive({
  backcode: "",
  token: "",
});

onMounted(async () => {
  // 获取 code 参数
  const code = router.currentRoute.value.query.code as string;
  GitHubCallBack(code);
});

//github authorization callback  api/OAuthGithub/GithubCallback
const GitHubCallBack = (code: string) => {
  axiosInstance
    .get("api/GithubAuth/GithubCallback", {
      params: {
        code: code,
      },
      timeout: 180000
    })
    .then((res) => {
      var result = res.data;
      if (result.success) {
        authStore.setToken(result.data.token);
        GetUserInfo(result.data.token);
      }
      else{
        ElMessage.error(result.msg);
        const redirectUrl = localStorage.getItem('OAUTH_LOGIN_URL') || '/';
        localStorage.removeItem('OAUTH_LOGIN_URL');
        router.push(redirectUrl);
      }
    });
};

// get userinfo by token
const GetUserInfo = (token: string) => {
  axiosInstance
    .get("api/UserInfo/GetUserInfoByToken", {
      params: {
        token: token
      },
    })
    .then((res) => {
      var result = res.data;
      pagestate.token = result.data;
      if (result.success) {
        userInfoStore.setUser(result.data);
        const redirectUrl = localStorage.getItem('OAUTH_LOGIN_URL') || '/';
        localStorage.removeItem('OAUTH_LOGIN_URL');
        router.push(redirectUrl);
      }
    });
};

return (_ctx: any,_cache: any) => {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[2] || (_cache[2] = _createElementVNode("div", null, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_icon, {
        class: "is-loading",
        style: {"font-size":"48px","margin-bottom":"16px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Loading)
        ]),
        _: 1
      }),
      _cache[0] || (_cache[0] = _createElementVNode("div", null, "正在链接GitHub服务器...", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("div", null, "如果中断，请多试几次", -1))
    ])
  ], 64))
}
}

})